import { ObservableArray, View } from "binder"
import { DeliveryCartableReportViewModel, SingleFactorBox } from "./deliveryCartableReport-viewModel"
import { ServerSideDataLoader } from "uicomponents";

export class DeliveryCartableReportView extends View<DeliveryCartableReportViewModel>{
    GetViewUniqueId(): string {
        return "V-E674D1BF-A985-41EE-9183-5D1C0BACEF99"
    }
    loadHtml(): string {
        let element = require('./deliveryCartableReport.html').default;
        let style = require('./deliveryCartableReport.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set factorBoxes(v: ObservableArray<SingleFactorBox>) { this._factorBoxes = v; } public get factorBoxes(): ObservableArray<SingleFactorBox> { return this._factorBoxes;} private _factorBoxes: ObservableArray<SingleFactorBox>;

}
